import ReactOnRails from 'react-on-rails';

import Download from '../bundles/TriipApp/download'
import HomePage from '../bundles/TriipApp/index'

ReactOnRails.register({
  Download,
  HomePage,
});
